import React from "react";
import { useSidebar } from "../ui/sidebar";

export function ViewSwitch() {
  const { toggleSidebar, open } = useSidebar();
  return (
    <div className="g-switch" js-flow-switch="true">
      <button
        className={[
          "g-switch__toggle",
          "flex items-center justify-center w-14 h-14 rounded-full transition-colors duration-150",
          open
            ? "text-white border border-blue-600"
            : "bg-white text-gray-700 border border-gray-200 hover:border-blue-400 hover:text-blue-700"
        ].join(" ")}
        type="button"
        aria-label="Toggle filters"
        style={{
          outline: 'none',
          backgroundColor: open ? '#2563eb' : undefined,
          borderColor: open ? '#2563eb' : undefined,
          color: open ? '#fff' : undefined
        }}
        onClick={(event) => {
          event.preventDefault();
          toggleSidebar();
        }}
      >
        <span>
          <svg
            width="22"
            height="22"
            viewBox="-2.4 -2.4 28.80 28.80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5M14 5H20M10 5L4 5M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12ZM16 12H4M8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19ZM8 19H20"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </svg>
        </span>
      </button>
      <button className="g-switch__btn -active" style={{ outline: 'none' }}>
        <span>
          <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <title>scale-minimize-solid</title>
            <g>
              <rect width="48" height="48" fill="none"></rect>
              <g>
                <path d="M36,30a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-4A10,10,0,1,0,46,36,10,10,0,0,0,36,26Z"></path>
                <path d="M27,17a2,2,0,0,0-2.3-2A2.1,2.1,0,0,0,23,17.1v3.1l-6.5-6.6a2.1,2.1,0,0,0-2.8-.1A1.8,1.8,0,0,0,13,15a2,2,0,0,0,.6,1.4L20.2,23H17.1A2.1,2.1,0,0,0,15,24.7,2,2,0,0,0,17,27h8a2,2,0,0,0,2-2Z"></path>
                <path d="M22,4a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2h0A2,2,0,0,1,22,4Z"></path>
                <path d="M12.3,7.7A2,2,0,0,1,13,4.9h0a2,2,0,0,1,2.7.8h0A1.9,1.9,0,0,1,15,8.4h0A1.9,1.9,0,0,1,12.3,7.7Z"></path>
                <path d="M5.7,15.7A2,2,0,0,1,4.9,13h0a2.1,2.1,0,0,1,2.8-.7h0A1.9,1.9,0,0,1,8.4,15h0A1.9,1.9,0,0,1,5.7,15.7Z"></path>
                <path d="M4,26a2,2,0,0,1-2-2H2a2,2,0,0,1,2-2H4a2,2,0,0,1,2,2H6A2,2,0,0,1,4,26Z"></path>
                <path d="M7.7,35.7A2,2,0,0,1,4.9,35h0a2,2,0,0,1,.8-2.7h0a1.9,1.9,0,0,1,2.7.7h0A1.9,1.9,0,0,1,7.7,35.7Z"></path>
                <path d="M15.7,42.3a2,2,0,0,1-2.7.8h0a2.1,2.1,0,0,1-.7-2.8h0a1.9,1.9,0,0,1,2.7-.7h0A1.9,1.9,0,0,1,15.7,42.3Z"></path>
                <path d="M26,44a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h0A2,2,0,0,1,26,44Z"></path>
                <path d="M44,22a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2h0A2,2,0,0,1,44,22Z"></path>
                <path d="M40.3,12.3a2,2,0,0,1,2.8.7h0a2,2,0,0,1-.8,2.7h0a1.9,1.9,0,0,1-2.7-.7h0A1.9,1.9,0,0,1,40.3,12.3Z"></path>
                <path d="M32.3,5.7A2,2,0,0,1,35,4.9h0a2.1,2,0,0,1,.7,2.8h0a1.9,1.9,0,0,1-2.7.7h0A1.9,1.9,0,0,1,32.3,5.7Z"></path>
              </g>
            </g>
          </svg>
          Stacks
        </span>
      </button>
      <button className="g-switch__btn" style={{ outline: 'none' }}>
        <span>
          <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <title>menu-dialpad-solid</title>
            <g>
              <rect width="48" height="48" fill="none"></rect>
              <g>
                <circle cx="24" cy="24" r="5"></circle>
                <circle cx="9" cy="24" r="5"></circle>
                <circle cx="39" cy="24" r="5"></circle>
                <circle cx="24" cy="39" r="5"></circle>
                <circle cx="9" cy="39" r="5"></circle>
                <circle cx="39" cy="39" r="5"></circle>
                <circle cx="24" cy="9" r="5"></circle>
                <circle cx="9" cy="9" r="5"></circle>
                <circle cx="39" cy="9" r="5"></circle>
              </g>
            </g>
          </svg>
          Grid
        </span>
      </button>
      <label className="g-speed g-speed--below">
        <span>Speed</span>
        <input
          type="range"
          min="0.2"
          max="8"
          step="0.1"
          defaultValue="1"
          js-flow-speed="true"
        />
      </label>
      <button
        className="g-switch__toggle g-switch__toggle--right"
        type="button"
        js-dark-toggle="true"
        aria-label="Toggle dark mode"
        style={{ outline: 'none' }}
      >
        <span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="currentColor"
              d="M13.2 11.9c-4.5 0-8.1-3.6-8.1-8.1 0-1.4 0.3-2.7 0.9-3.8-3.4 0.9-6 4.1-6 7.9 0 4.5 3.6 8.1 8.1 8.1 3.1 0 5.8-1.8 7.2-4.4-0.6 0.2-1.3 0.3-2.1 0.3zM8.1 15c-3.9 0-7.1-3.2-7.1-7.1 0-2.5 1.3-4.7 3.3-6-0.2 0.6-0.2 1.2-0.2 1.9 0 5 4.1 9.1 9.1 9.2-1.4 1.2-3.2 2-5.1 2z"
            />
          </svg>
        </span>
      </button>
    </div>
  );
}
